
// INTERNSHIP SERVICES
export const GET_INTERNSHIP_SERVICES = "/api/v1/internship-services";
export const ADD_NEW_INTERNSHIP_SERVICE = "/api/v1/internship-services";
export const UPDATE_INTERNSHIP_SERVICE = "/api/v1/internship-services";
export const DELETE_INTERNSHIP_SERVICE = "/api/v1/internship-services";


